import styled from 'styled-components'
import { breakpoints, colors } from '@/styles'
import SparkleSVG from './../sparkle.svg?react'

export const SectionWrapper = styled.div`
  padding: 24px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);

  @media screen and (max-width: ${breakpoints.phoneMax}) {
    padding: 8px;
  }
`

export const StyledSVG = styled(SparkleSVG)`
  margin-right: 12px;
`

export const Title = styled.p`
  font-family: 'Inter';
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;
  color: ${colors.black};
  margin: 0;
`

export const Description = styled.p`
  font-family: 'Inter';
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: ${colors.grey40};
`

export const ButtonRow = styled.div`
  display: flex;
  justify-content: flex-end;
  background-color: ${colors.grey96};
  width: 100%;
  padding: 16px;
`

export const TextAreaBottomBar = styled.div<{ justifyContent?: string }>`
  position: sticky;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: ${({ justifyContent }) => justifyContent ?? 'flex-start'};
  box-sizing: border-box;
  padding: 16px;
`
